// extracted by mini-css-extract-plugin
export var fadeInOut = "_2d-3";
export var icon = "_2d-4";
export var savedIndicator = "_2d-2";
export var savingIndicator = "_2d-0";
export var spin = "_2d-1";